<template>
    <div v-if="show_updated">
        <div class="p-6 text-center">
            <base-svg
                name="illustration-confirmation"
                class="w-full max-w-2xs mb-6 mx-auto"
            />

            <h6 class="font-semibold text-lg font-normal mb-3">
                Password reset!
            </h6>

            <p class="text-grey-darker">
                Your password has been updated. You can log in with it now.
            </p>
        </div>

        <div class="bg-grey-bg text-right rounded-b px-6 py-3">
            <router-link
                :to="{ name: 'auth.sessions.create' }"
                class="btn btn-blue w-full"
            >
                Go to Login
            </router-link>
        </div>
    </div>

    <password-resets-update
        v-else
        :params="{ reset: $route.params.token }"
        @success="onSuccess"
    >
        <base-form
            slot-scope="{
                sid,
                error,
                is_loading: is_saving,
                update
            }"
            @submit="update(form)"
        >
            <div class="pt-4 px-4 sm:pt-6 sm:px-6">
                <h6 class="text-center font-semibold text-lg font-normal mb-3">
                    Password reset
                </h6>

                <p class="text-grey-darker text-sm mb-6">
                    Enter a new password to reset the password on your account.
                </p>

                <validator-alert :sid="sid" />

                <form-item
                    :sid="sid"
                    :is-required="true"
                    name="password"
                >
                    <template slot="label">Password</template>

                    <input-text
                        v-model="form.password"
                        :sid="sid"
                        :autofocus="true"
                        :disabled="is_saving"
                        name="password"
                        type="password"
                    />
                </form-item>
            </div>

            <div class="bg-grey-bg rounded-b p-4 sm:px-6">
                <base-button
                    :is-loading="is_saving"
                    class="btn-blue w-full"
                >
                    Set new password
                </base-button>
            </div>

            <error-modal
                v-if="error && $error.is(error, { exclude: [400, 422] })"
                :error="error"
            />
        </base-form>
    </password-resets-update>
</template>

<script>
    import HeadMixin from '../../../mixins/head'
    import PasswordResetsUpdate from '../../../components/password-resets-update'

    export default {
        mixins: [
            HeadMixin
        ],
        components: {
            PasswordResetsUpdate
        },
        data () {
            return {
                show_updated: false,
                form: {
                    password: ''
                }
            }
        },
        methods: {
            head () {
                return {
                    title: 'Password reset'
                }
            },
            onSuccess () {
                this.show_updated = true
            }
        }
    }
</script>
